var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestonic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#7A1113"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28394 4.99818H10.9615C10.9615 4.99818 11.273 4.96834 11.273 5.39731V7.65032C11.273 7.65032 12.2354 5.96616 13.4682 5.09703C13.4682 5.09703 14.2105 4.50394 15.4153 4.58041C15.4153 4.58041 17.0193 4.53565 17.7784 5.9587C17.7784 5.9587 18.2074 6.79612 17.8716 7.60183C17.6366 8.16695 17.3364 8.4206 16.5586 8.58286C16.5586 8.58286 14.8577 8.81972 14.6208 7.2773C14.6208 7.2773 14.4157 6.39139 15.0442 5.89901C15.0442 5.89901 14.563 5.57822 13.8338 6.08179C13.8338 6.08179 11.3476 7.74544 11.3476 10.9459V18.5815H13.8487C13.8487 18.5815 14.1191 18.6039 14.1191 18.9452C14.1191 18.9452 14.1266 19.4264 13.8282 19.4264H6.33616C6.33616 19.4264 6.04335 19.3537 6.04335 18.9825C6.04335 18.9825 6.02097 18.5815 6.28394 18.5815H8.82231V5.90088H6.32124C6.32124 5.90088 6.00045 5.88969 6.00045 5.44207C6.00045 5.44207 5.9762 4.99818 6.28394 4.99818Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestonic);
export default __webpack_public_path__ + "static/media/Restonic.670ff42f181acbec63e8a99cb4f83a98.svg";
export { ForwardRef as ReactComponent };